/**
 * Top Games Numbers Component
 * Shows ranking numbers on top games
 */

import React from 'react';
import Image from '../../../../../../shared/components/Image';
import { MAX_TOP_GAMES } from '../../../../../../constants';

import styles from './TopGamesNumbers.module.css';

interface TopGamesNumbersProps { index: string; }

const TopGamesNumbers: React.FC<TopGamesNumbersProps> = ({ index }) => {

  // Only show for the first MAX_TOP_GAMES games (the number sprites only go that far)
  const numIndex = parseInt(index);
  if (numIndex > MAX_TOP_GAMES) {
    return null;
  }

  return (
    <div key={index} className={`${styles.TopGamesNumberContainer}`}>
      <Image
        src={`/top_games_numbers/${index}`}
        alt={`#${index}`}
        loading="eager"
      />
    </div>
  );
};


export default TopGamesNumbers; // no memoize the component because dinamiclly changing data (index) can lead to ordering issues.